var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loader",
    {
      attrs: {
        width: 480,
        height: 600,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("circle", { attrs: { cx: "120", cy: "304", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "150",
          y: "301",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "120", cy: "334", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "150",
          y: "331",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "120", cy: "364", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "150",
          y: "361",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "120", cy: "394", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "150",
          y: "391",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "170",
          y: "19",
          rx: "0",
          ry: "0",
          width: "161",
          height: "123",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "77",
          y: "170",
          rx: "0",
          ry: "0",
          width: "360",
          height: "43",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "77",
          y: "235",
          rx: "0",
          ry: "0",
          width: "279",
          height: "41",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "182",
          y: "427",
          rx: "0",
          ry: "0",
          width: "138",
          height: "33",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "87",
          y: "484",
          rx: "0",
          ry: "0",
          width: "329",
          height: "26",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "87",
          y: "529",
          rx: "0",
          ry: "0",
          width: "96",
          height: "23",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }